import React from 'react';
import BtnAdd from '../../buttons/BtnAdd';
import { FaSearch } from 'react-icons/fa';


const HeaderComplete = ({ title, to, searchTerm, funtion }) => {

    return (
        <div className='w-[80%] flex text-2xl font-semibold items-center justify-center gap-2'>
            <div className='flex gap-2 pb-1'>
                <h1>{title}</h1>
            </div>
            <div className='flex items-center w-full' >
                <input
                    value={searchTerm}
                    onChange={funtion}
                    placeholder='Buscar ...'
                    className="w-full outline-none input-bordered focus:outline-none focus:ring-1  text-sm border font-normal p-1 rounded-sm"
                    type="text"
                />
            </div>

        </div>
    );
};

export default HeaderComplete;